import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, NonNullableFormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { CustomPatterns, CustomValidators } from '@cargos/sprintpay-utils';
import { PaymentCartTypeType } from 'src/app/shared/models/payment-type';
import { SummaryService } from 'src/app/shared/services';
import { PaymentCartTypeHandlerService } from 'src/app/shared/services/payment-cart-type-handler.service';
import { PaymentTypeConfiguration } from '../models/awb-search-form';
import { FirmsCodeFormGroupType } from '../models/firms-code-form';
import { formFirmsCodeErrors } from '../utils/form-errors';
@Component({
    selector: 'app-payment-type-selector',
    templateUrl: './payment-type-selector.component.html',
    styleUrls: ['./payment-type-selector.component.scss'],
    standalone: false,
})
export class PaymentTypeSelectorComponent implements OnInit {
    public mawb: string | null = '';
    public PaymentCartTypeType = PaymentCartTypeType;
    public paymentConfiguration: PaymentTypeConfiguration;
    public firmsCodeForm: FirmsCodeFormGroupType;
    public formErrors = formFirmsCodeErrors;

    @Input() set paymentSelectorConfig(configuration: PaymentTypeConfiguration) {
        if (configuration) {
            this.paymentConfiguration = configuration;
        }
    }
    @Input() firmsCodesBlackList: string[] = [];

    get firmsCode(): AbstractControl<string> | null {
        return this.firmsCodeForm.get('firmsCode');
    }

    constructor(
        private summaryService: SummaryService,
        private paymentCartTypeHandlerService: PaymentCartTypeHandlerService,
        private formBuilder: NonNullableFormBuilder
    ) {}

    ngOnInit(): void {
        this.getMAWB();
        this.createForm();
    }

    setTabSelected(paymentCartType: PaymentCartTypeType): void {
        this.paymentCartTypeHandlerService.setPaymentCartType(paymentCartType);
    }

    selectPaymentType(paymentCartTypeType: PaymentCartTypeType): void {
        if (this.isFirmsCodeInBlackList(this.firmsCode?.value || '')) {
            this.firmsCode?.setErrors({ regex: true });

            return;
        }

        if (paymentCartTypeType === PaymentCartTypeType.MAWB) {
            this.saveFirmsCode();
        }

        this.setTabSelected(paymentCartTypeType);
    }

    isFirmsCodeInBlackList(firmCode: string): string {
        return this.firmsCodesBlackList.find((firmsCode) => firmsCode?.toLowerCase() === firmCode?.toLowerCase()) || '';
    }

    getMAWB(): void {
        this.mawb = this.summaryService.getMAWB();
    }

    createForm(): void {
        this.firmsCodeForm = this.formBuilder.group({
            firmsCode: [
                '',
                [
                    Validators.required,
                    CustomValidators.regex(new RegExp(CustomPatterns.FIRMS_CODE_REGEX)),
                    this.isFirmsCodeValid(),
                ],
            ],
        });
    }

    saveFirmsCode(): void {
        this.summaryService.setFirmsCode(this.firmsCode?.value || '');
    }

    isFirmsCodeValid(): ValidatorFn {
        return (control: AbstractControl<string>): ValidationErrors | null => {
            if (control.value == null) {
                return null;
            }

            return !this.isFirmsCodeInBlackList(control.value)
                ? null
                : {
                      regex: true,
                  };
        };
    }
}
